import { render, staticRenderFns } from "./HomePart4.vue?vue&type=template&id=35784338&scoped=true&"
import script from "./HomePart4.vue?vue&type=script&lang=js&"
export * from "./HomePart4.vue?vue&type=script&lang=js&"
import style0 from "./HomePart4.vue?vue&type=style&index=0&id=35784338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35784338",
  null
  
)

export default component.exports